import * as analytics from '@gitbook/app-analytics/client';
import { resolveURLToNavigation } from '@gitbook/app-navigation';

import { useNavigation } from '../../navigation';
import type { NotificationData } from './notifications';

/**
 * Returns a callback to open a notification.
 */
export function useOpenNotification(): (notification: NotificationData) => void {
    const { navigate } = useNavigation();

    return (notification) => {
        analytics.logEvent(
            analytics.createNotificationEvent(notification, {
                type: 'notification_open',
            })
        );

        if (notification.actionUrl) {
            const screen = resolveURLToNavigation(notification.actionUrl);
            if (!screen) {
                window.location.href = notification.actionUrl;
            } else {
                navigate({ screen });
            }
        }

        if (!notification.isRead) {
            void notification.markAsRead();
        }
    };
}
